import http from "services/httpService";
import { object, string, array } from "yup";
import config from "../../config.json";

export const generateInitialValues = (data, type) => {
  const profileData = data?.data || {}; // Make sure profileData is an object
  const hasPrimaryContact =
    Array.isArray(profileData?.primary_contact) &&
    profileData.primary_contact.length > 0;
  const primaryContact = hasPrimaryContact ? profileData.primary_contact[0] : {};
  const initialValues = {};
  const addressKeys = ["street", "city", "state"];
  const managers = ["relationship_managers", "servicing_managers"];
  const keys = [
    "company_name",
    "parent_company_name",
    "range_of_employees",
    "industry",
    "industry_sector",
    ...addressKeys,
    "pincode",
    "primary_contact_name",
    "email",
    "phone",
    "secondary_contacts",
    ...managers,
  ];

  keys.forEach((key) => {
    if (addressKeys.includes(key)) {
      initialValues[key] = profileData?.address?.[key] || "";
    } else if (managers.includes(key)) {
      initialValues[key] = profileData?.[key]?.map(({ id }) => id) ?? [];
    } else if (key === "secondary_contacts") {
      initialValues[key] = profileData?.secondary_contacts?.length
        ? profileData.secondary_contacts.map(sc => ({
            name: sc.name || "",
            email: sc.email || "",
            phone_no: sc.phone_no || "",
          }))
        : [{ name: "", email: "", phone_no: "" }];
    } else if (key === "primary_contact_name") {
      initialValues[key] = hasPrimaryContact
        ? (primaryContact?.name || "")
        : (profileData?.primary_contact_name || "");
    } else if (key === "email") {
      initialValues[key] = hasPrimaryContact
        ? (primaryContact?.email || "")
        : (profileData?.email || "");
    } else if (key === "phone") {
      initialValues[key] = hasPrimaryContact
        ? (primaryContact?.phone_no || "")
        : (profileData?.phone || "");
    } else {
      initialValues[key] = profileData?.[key] || "";
    }
  });

  return initialValues;
};

export const postCompanyData = async (company_data, type) => {
  const formattedData = {
    primary_contact: {
      phone_no: company_data?.phone,
      email: company_data?.email,
      name: company_data?.primary_contact_name,
    },
    company: {
      source: "",
      company_name: company_data?.company_name,
      industry: company_data?.industry,
      parent_company_name: company_data?.parent_company_name,
      industry_sector: company_data?.industry_sector,
      range_of_employees: company_data?.range_of_employees,
      pincode: company_data?.pincode,
    },
    secondary_contacts: (company_data?.secondary_contacts || []).filter(
      (contact) => contact.phone_no || contact.email || contact.name
    ).map((contact) => ({
      phone_no: contact.phone_no,
      email: contact.email,
      name: contact.name,
    })),
    address: {
      type: "Current Address",
      street: company_data?.street,
      state: company_data?.state,
      city: company_data?.city,
      pincode: company_data?.pincode,
    },
  };

  try {
    if (type == "edit") {
      const data = await http.post("/business/edit_company/", formattedData);
      const setPocMapping = await http.post(
        "/business/attach_poc_to_company/",
        {
          poc_managers: (company_data?.servicing_managers).concat(
            company_data?.relationship_managers
          ),
        }
      );
      return true;
    } else {
      

      const data = await http.post("/users/user/", formattedData);
      const flow = localStorage.getItem("flow");
      localStorage.setItem("id", data.data.id);
      if (flow == "GMC") {
        localStorage.setItem("gmc_company_id", data.data.company.id);
      }
      const profile_data = await http.get("/phone/get_token/", {
        params: {
          user_id: data.data.id,
        },
      });
      localStorage.setItem("token", profile_data.data.token);
      const setPocMapping = await http.post(
        "/business/attach_poc_to_company/",
        {
          poc_managers: (company_data?.servicing_managers).concat(
            company_data?.relationship_managers
          ),
        },
        {
          headers: {
            Authorization: `${config.jwtPrefix} ${profile_data.data.token}`,
          },
        }
      );
      return true;
    }
  } catch (e) {
    if (e.response.data.pincode) {
      alert(e.response.data.pincode[0]);
    } else if (e.response.data.company) {
      alert(e.response.data.company["gst_no"]);
    } else {
      alert(e.response.data.phone[0]);
    }
    return false;
  }
};

export const validationSchema = object({
  company_name: string().required("Company name is required"),
  // parent_company: string().required('Parent company is required'),
  range_of_employees: string().required(
    "Number of employees must be a positive number"
  ),
  industry: string().required("Industry type is required"),
  industry_sector: string().required("Industry sector is required"),
  street: string().required("Area is required"),
  city: string().required("City is required"),
  pincode: string().required("Pindoce is required"),
  state: string().required("State is required"),
  primary_contact_name: string().required("Primary name is required"),
  email: string()
    .required("Primary email is required")
    .email("Invalid email address"),
  phone: string()
    .required("Primary number is required")
    .matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
  secondary_contacts: array().of(
    object().shape({
      name: string(),
      email: string().email("Invalid email address"),
      phone_no: string().matches(/^\d{10}$/, "Please enter a valid 10-digit phone number"),
    })
  ),
  relationship_managers: array().required("Relation manager is required"),
  servicing_managers: array().required("Servicing manager is required"),
});
